/**
 * Breadcrumb Configuration Constants
 * Quản lý cấu hình breadcrumb cho các trang khác nhau
 */

export interface BreadcrumbConfig {
  /** Các pathname mà breadcrumb sẽ có isAbsolute = true */
  absolutePaths: string[]
  /** Các title keywords mà breadcrumb sẽ có isAbsolute = true */
  absoluteTitleKeywords: string[]
}

/**
 * Cấu hình breadcrumb cho từng locale
 */
export const BREADCRUMB_CONFIG: Record<string, BreadcrumbConfig> = {
  vi: {
    absolutePaths: [
      "/en-self-guieded-tour-new",
      "/vi/self-guided-tour-vi",
      "/bike-rental",
      "/vi/bike-rental-vi",
      "/all-tours",
      " /vi/all-tours-vi",
    ],
    absoluteTitleKeywords: [],
  },
  en: {
    absolutePaths: [
      "/en-self-guieded-tour-new",
      "/vi/self-guided-tour-vi",
      "/bike-rental",
      "/vi/bike-rental-vi",
      "/all-tours",
      "/vi/all-tours-vi",
    ],
    absoluteTitleKeywords: [],
  },
}

/**
 * Default configuration khi không tìm thấy locale
 */
export const DEFAULT_BREADCRUMB_CONFIG: BreadcrumbConfig = {
  absolutePaths: ["/en-self-guieded-tour-new", "/vi/self-guided-tour-vi", "/all-tours"],
  absoluteTitleKeywords: [],
}
